import { useEffect, useState } from 'react';
import { FEATURE_TAGS_SEPARATOR, FEATURE_TAGS_STORAGE_KEY, readFeatureTags } from './utils';

export function useFeatureToggle(featureTag: string) {
  const [featureTags, setFeatureTags] = useState<string[]>([]);
  const [featureTagOn, setFeatureTagOn] = useState(false);

  useEffect(() => {
    const featureTags = readFeatureTags();
    setFeatureTags(featureTags);
  }, []);

  useEffect(() => {
    setFeatureTagOn(featureTags.some(tag => tag === featureTag));
  }, [featureTags, featureTag]);

  const toggleFeatureTag = (featureTag: string): void => {
    const newValue = !featureTagOn;
    setFeatureTagOn(newValue);

    const featureTags = readFeatureTags().filter(tag => tag !== featureTag);
    const newFeatureTags = [...featureTags, ...(newValue ? [featureTag] : [])].join(FEATURE_TAGS_SEPARATOR);
    localStorage.setItem(FEATURE_TAGS_STORAGE_KEY, newFeatureTags);
  };

  return { value: featureTagOn, toggleFeatureTag };
}
